import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { adminRoutes } from './adminRoutes';
import { companyRoutes } from './companyRoutes';
import { professionalRoutes } from './professionalRoutes';
import { userRoutes } from './userRoutes';
import { publicRoutes } from './publicRoutes';
import { RootLayout } from '@/layouts';

const routes = [
	{
		path: '/',
		element: <RootLayout />,
		children: [
			...publicRoutes,
			...userRoutes,
			...professionalRoutes,
			...adminRoutes,
			...companyRoutes,
		],
	},
];

const router = createBrowserRouter(routes);

const Provider = () => <RouterProvider router={router} />;

export { Provider as RouterProvider };
